
<script>
  import {Navigation, Pagination, A11y} from 'swiper';
  import {Swiper, SwiperSlide } from 'swiper/svelte';
  import {fade} from 'svelte/transition'
  import {push, pop, replace} from 'svelte-spa-router'
  import {Button, Form, TextInput, Select, SelectItem, Checkbox, DatePicker, DatePickerInput} from 'carbon-components-svelte';
  import OtpInput from 'svelte-otp'
  import {Motion, M} from 'svelte-motion'
  import {getAuth, signInWithPhoneNumber, RecaptchaVerifier} from "firebase/auth";
  import {animateScroll} from 'svelte-scrollto-element'
  import {_} from 'svelte-i18n'
  import TelInput, { normalizedCountries } from 'svelte-tel-input';

  import {getUserData} from '../userdata.js'

  import {itemB} from './animations.js'
  import Tailwindcss from '../Tailwind.svelte'
  import {registerUser} from '../auth';
  import {getCountries}  from '../userdata'
  import {makeOrder, skrillPrepare} from '../payments.js';
  import {auth} from '../firebase.js'
  /* import {itemB} from './animations' */
  import {sessionData} from '../stores'
  import {onMount} from 'svelte';
  import {signInWithGoogle} from '../auth'

  // Any Country Code Alpha-2 (ISO 3166)
  const SOFORT_COUNTRIES = ['DE', 'AT', 'NL', 'ES', 'BE', 'PL', 'SE', 'NO']
  /* export let variants */
  /* export let container */
  /* export let animate */
  /* export let trigger */

  function parseCustomAmount(customAmountField) { // :: String -> Either String Integer
    const amount = parseInt(customAmountField.substr(1))
    if (Number.isInteger(amount)) {
      if      (amount <  10) return 'too_little'
      else if (amount > 500) return 'too_large'
      else                   return amount
    } else {
      return 'invalid' // not parsable as integer
    }
  }

  function customAmountError(customAmountField) {
    switch (parseCustomAmount(customAmountField)) {
      case 'too_little': return $_("common.minTop")
      case 'too_large': return $_("common.maxTop")
      default: return ''
    }
  }

  $: ten_sel = selection == '10' ? "selected" : (selection == '50' ? "deselected_left" : "deselected")
  /* $: ten_sel = selection == '10' ? "selected" : (selection == '50' ? "deselected" : "deselected_left") */
  /* $: twofive_sel = selection == 'twofive' ? "selected" : "deselected" */
  $: twofive_sel = selection == '25' ? "selected" : (selection == '10' ? "deselected_right" : "deselected")
  $: thirty_sel = selection == '50' ? "selected" : (selection == '10' ? "deselected_middle" : "deselected_right")
  $: currentCustomAmount = customAmount == '$0' ? selection  : parseInt(customAmount.substr(1))
  $: customActive = customAmount == '$0' ? false : true
  $: error = customAmountError(customAmount)
  $: {
    let number = parseInt(customAmount.substr(1))
    if(isNaN(number)) customAmount = '$0'
    else              customAmount = '$' + number.toString()
  }

  let customAmount = "$0"
  let selection = '25'

  function getAmount(customAmountField) {
    const customAmount_ = parseCustomAmount(customAmountField)
    console.debug('customAmount_', customAmount_)
    if (customActive) {
      if (Number.isInteger(customAmount_)) { return customAmount_ }
      else { return undefined }
    } else {
      return selection
    }
  }

  async function handleOrder(){
    const amount = getAmount(customAmount)
    console.debug("handleOrder, amount", amount)
    if (amount) {
      window.open((await makeOrder(amount)).link)
    }
  }

  async function handleSkrill() {
    const amount = getAmount(customAmount)
    console.debug('handleSkrill, amount', amount)
    if(amount) {
      window.open(await skrillPrepare(amount))
    }
  }

  function switcher(amount) {
    customAmount = "$0"
    selection = amount
  }

  const carouselInactive = {
    opacity: 0.2
  }

  const amount = {
    deselected: {
      scale: 0.5,
      opacity: 0.5,
      x: 43,
      y: 5
    },
    deselected_right: {
      scale: 0.5,
      opacity: 0.5,
      x: -43,
      y: 5
    },
    deselected_middle: {
      scale: 0.5,
      opacity: 0.5,
      x: -100,
      y: 5
    },
    deselected_left: {
      scale: 0.5,
      opacity: 0.5,
      x: 75,
      y: 5
    },
    selected: {
      scale: 1,
      opacity: 1,
      x: 0,
      y: 0,
    },
  }

  const amounts = {
    '10': { x: 55 },
    '25': { x: -55 },
    '50': { x: -165 },
  }
  onMount(() => {
  })
</script>

<Tailwindcss/>

<M.div class="select-none flex gap-x-3 flex-row">
  <M.div class="h-32 w-1 bg-white"/>
  <div class="transition-all" class:opacity-30={customActive}>
    <M.div class="flex flex-col">
      <M.h1 class="font-brown select-none text-xl8">{$_("payment.topUp")}</M.h1>
      <M.div animate={selection} initial="25" variants={amounts} class="flex flex-row gap-x-8">
        <M.h1 variants={amount} initial="deselected" animate={ten_sel} whileTap={() => switcher('10')} class="cursor-pointer font-autoscape text-xl6">$10</M.h1>
        <M.h1 variants={amount} initial="selected" animate={twofive_sel} class="cursor-pointer select-none font-autoscape text-xl8" whileTap={() => switcher('25')}>$25</M.h1>
        <M.h1 variants={amount} initial="deselected_right" animate={thirty_sel} whileTap={() => switcher('50')} class="cursor-pointer font-autoscape text-xl8 ">$50</M.h1>
      </M.div>

    </M.div>
  </div>
</M.div>

<input bind:value={customAmount} type="text" class:opacity-100={customActive} class="mt-16 ml-0 w-40 h-12 text-4xl font-autoscape border-b-4 caret-gray-100 pb-4 focus:outline-none focus:opacity-100 transition-opacity bg-space text-white opacity-50" placeholder="custom amount" />
<div class="h-8 py-5">
  {#if error != ""}
    <h3 transition:fade class="font-autoscape opacity-50 text-gray text-sm">{error}</h3>
  {/if}
</div>

<M.h3 class="mt-16 ml-0 text-xl2 font-brown text-white opacity-50">
  {$_("payment.payWith")}
</M.h3>

<M.div class="pay-buttons">
  <img
    on:click={handleOrder}
    src="paypal.png"
    alt="paypal"
    class="transition-all hover:scale-105 cursor-pointer pay-button"
    />
  <img
    on:click={handleSkrill}
    alt="Pay by Skrill button"
    src="skrill-payby-btn-purple_245x75.png"
    class="transition-all hover:scale-105 cursor-pointer pay-button"
    />
</M.div>

<style>
  .pay-button {
    width: 12rem;
    margin: 1.2rem 0;
  }
</style>
